// extracted by mini-css-extract-plugin
export default {"chatBody":"ChatBody_chatBody__SUuqX","chatBodyInner":"ChatBody_chatBodyInner__64a3G","oldMessage":"ChatBody_oldMessage__EDtpD"};